import React, { memo } from "react";
import { Box } from "@UI/Components/Box/Box";
import useIsVisible from "@UI/hooks/useIsVisible";

interface IMetricProgressBar {
  value: number;     // current percentage (0–100) — bar fill
  threshold: number; // target percentage (0–100) — marker line position
}

export const MetricProgressBar = memo(({ value, threshold }: IMetricProgressBar) => {
  const isReached = value >= threshold;
  const clampedValue = Math.min(Math.max(value, 0), 100);
  const clampedThreshold = Math.min(Math.max(threshold, 0), 100);

  const { ref: trackRef, isVisible } = useIsVisible<HTMLDivElement>();

  return (
    // py gives the threshold marker room to protrude above/below the track without being clipped
    <Box position="relative" py="3px" ref={trackRef}>
      <Box h="16px" bg="gray.200" rounded="full" overflow="hidden">
        <Box
          h="full"
          rounded="full"
          bg={isReached ? "seaGreen.500" : "red.300"}
          w={isVisible ? `${clampedValue}%` : "0%"}
          transition="width 0.8s ease-out"
        />
      </Box>
      <Box
        position="absolute"
        top={0}
        bottom={0}
        w="2px"
        bg="#333333"
        left={`${clampedThreshold}%`}
        transform="translateX(-50%)"
        rounded="sm"
      />
    </Box>
  );
});

MetricProgressBar.displayName = "MetricProgressBar";
